export default "__VITE_ASSET__f70LyKpa__"